import React from 'react';

import SearchInput from '../../SearchInput';

// TO DO - add app search
const Search = () => (
  <form>
    <SearchInput placeholder="Search apps" />
  </form>
)

export default Search;